import { FormEvent, useState } from 'react';
import type { AdminUser } from '../AdminApp';

type LoginPageProps = {
  onAuthenticated: (user: AdminUser) => void;
};

export function LoginPage({ onAuthenticated }: LoginPageProps) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setError('');
    setIsSubmitting(true);

    try {
      const response = await fetch('/api/admin/login', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ email, password })
      });

      if (!response.ok) {
        setError('The email or password is incorrect.');
        return;
      }

      const json = (await response.json()) as { user?: AdminUser };

      if (!json.user) {
        setError('The email or password is incorrect.');
        return;
      }

      onAuthenticated(json.user);
    } catch {
      setError('The email or password is incorrect.');
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <section className="admin-panel login-panel" aria-labelledby="admin-login-title">
      <div>
        <p className="eyebrow">Secure Area</p>
        <h2 id="admin-login-title">Admin Login</h2>
        <p>Sign in to manage Society of Mystics content, resources, and contact submissions.</p>
      </div>
      <form className="admin-form" onSubmit={handleSubmit}>
        <label>
          Email
          <input
            name="email"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
          />
        </label>
        <label>
          Password
          <input
            name="password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />
        </label>
        {error ? <p role="alert">{error}</p> : null}
        <button className="button-primary" type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Signing In' : 'Sign In'}
        </button>
      </form>
    </section>
  );
}
